module.exports = __webpack_public_path__ + "fonts/NespressoLucas-BoldItalic.ttf?v=98653feea2b56ce3bcc89b68590e1679";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-BoldItalic.ttf
// module id = 646
// module chunks = 0